<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow:auto;height: calc(100vh - 179px);">
            <es-org-tree @clickByOrg="reportData" @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>报表导出
          </div>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>故障报表</span>
                </div>
                <div class="box-card">
                  <el-row>
                    <el-date-picker size="mini" v-model="faultDate" type="daterange" align="right" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                      :picker-options="pickerOptions">
                    </el-date-picker>
                  </el-row>
                  <el-row>
                    <el-button type="primary" size="small" :loading="faultloading" @click="faultReport"
                      class="report-button" plain>故障导出</el-button>
                  </el-row>
                </div>
              </el-card>
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>保养报表</span>
                </div>
                <div class="box-card">
                  <el-row>
                    <el-date-picker size="mini" v-model="maintainDate" type="daterange" align="right" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                      :picker-options="pickerOptions">
                    </el-date-picker>
                  </el-row>
                  <el-row>
                    <el-button type="primary" size="small" :loading="maintainloading" @click="maintainReport"
                      class="report-button" plain>保养导出
                    </el-button>
                  </el-row>
                </div>
              </el-card>
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>人员报表</span>
                </div>
                <div class="box-card">
                  <el-row>
                    <el-date-picker size="mini" v-model="userDate" type="daterange" align="right" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                      :picker-options="pickerOptions">
                    </el-date-picker>
                  </el-row>
                  <el-row>
                    <el-button type="primary" size="small" :loading="userloading" @click="userReport"
                      class="report-button" plain>人员导出
                    </el-button>
                  </el-row>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>巡检报表</span>
                </div>
                <div class="box-card">
                  <el-row>
                    <el-date-picker size="mini" v-model="insDate" type="daterange" align="right" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                      :picker-options="pickerOptions">
                    </el-date-picker>
                  </el-row>
                  <el-row>
                    <el-button type="primary" size="small" :loading="insloading" @click="insReport"
                      class="report-button" plain>巡检导出
                    </el-button>
                  </el-row>
                </div>
              </el-card>
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>任务报表</span>
                </div>
                <div class="box-card">
                  <el-row>
                    <el-date-picker size="mini" v-model="taskDate" type="daterange" align="right" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                      :picker-options="pickerOptions">
                    </el-date-picker>
                  </el-row>
                  <el-row>
                    <el-button type="primary" size="small" :loading="taskloading" @click="taskReport"
                      class="report-button" plain>任务导出
                    </el-button>
                  </el-row>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'
export default {
  name: 'report',
  props: ["funcs"],
  data () {
    return {
      orgTree: [],//所属组织
      queryObj: {
        orgIds: '',
        startTime: "",
        endTime: "",
      },
      faultDate: [],
      faultloading: false,
      insDate: [],
      insloading: false,
      maintainDate: [],
      maintainloading: false,
      taskDate: [],
      taskloading: false,
      repairDate: [],
      repairloading: false,
      userloading: false,
      userDate: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  methods: {
    initOrgTree (orgTree) {
      this.orgTree = orgTree
    },
    /*故障*/
    faultReport () {
      this.faultloading = true
      if (this.faultDate.length === 0) {
        this.$message.error("请选择时间范围")
        this.faultloading = false
        return
      }
      this.$set(this.queryObj, "startTime", dateutils.dateFormat("YYYY-mm-dd", this.faultDate[0]) + ' 00:00:00')
      this.$set(this.queryObj, "endTime", dateutils.dateFormat("YYYY-mm-dd", this.faultDate[1]) + ' 23:59:59')
      let url = '/buss/report/faultReport'
      this.$ajax.downFile(url, this.queryObj).then((msg) => {
        this.faultloading = false
        this.faultDate = []
        this.$message.success(msg)
      }).catch(err => {
        this.$message.error(err)
        this.faultloading = false
      })
    },
    maintainReport () {
      this.maintainloading = true
      if (this.maintainDate.length === 0) {
        this.$message.error("请选择时间范围")
        this.maintainloading = false
        return
      }
      this.$set(this.queryObj, "startTime", dateutils.dateFormat("YYYY-mm-dd", this.maintainDate[0]) + ' 00:00:00')
      this.$set(this.queryObj, "endTime", dateutils.dateFormat("YYYY-mm-dd", this.maintainDate[1]) + ' 23:59:59')
      let url = '/buss/report/maintainReport'
      this.$ajax.downFile(url, this.queryObj).then((msg) => {
        this.maintainloading = false
        this.maintainDate = []
        this.$message.success(msg)
      }).catch(err => {
        this.$message.error(err)
        this.maintainloading = false
      })
    },
    repairReport () {
      this.repairloading = true
      if (this.repairDate.length === 0) {
        this.$message.error("请选择时间范围")
        this.repairloading = false
        return
      }
      this.$set(this.queryObj, "startTime", dateutils.dateFormat("YYYY-mm-dd", this.repairDate[0]) + ' 00:00:00')
      this.$set(this.queryObj, "endTime", dateutils.dateFormat("YYYY-mm-dd", this.repairDate[1]) + ' 23:59:59')
      let url = '/buss/report/repairReport'
      this.$ajax.downFile(url, this.queryObj).then((msg) => {
        this.repairloading = false
        this.repairDate = []
        this.$message.success(msg)
      }).catch(err => {
        this.$message.error(err)
        this.repairloading = false
      })
    },
    insReport () {
      this.insloading = true
      if (this.insDate.length === 0) {
        this.$message.error("请选择时间范围")
        this.insloading = false
        return
      }
      this.$set(this.queryObj, "startTime", dateutils.dateFormat("YYYY-mm-dd", this.insDate[0]) + ' 00:00:00')
      this.$set(this.queryObj, "endTime", dateutils.dateFormat("YYYY-mm-dd", this.insDate[1]) + ' 23:59:59')
      let url = '/buss/report/insReport'
      this.$ajax.downFile(url, this.queryObj).then((msg) => {
        this.insloading = false
        this.insDate = []
        this.$message.success(msg)
      }).catch(err => {
        this.$message.error(err)
        this.insloading = false
      })
    },
    taskReport () {
      this.taskloading = true
      if (this.taskDate.length === 0) {
        this.$message.error("请选择时间范围")
        this.taskloading = false
        return
      }
      this.$set(this.queryObj, "startTime", dateutils.dateFormat("YYYY-mm-dd", this.taskDate[0]) + ' 00:00:00')
      this.$set(this.queryObj, "endTime", dateutils.dateFormat("YYYY-mm-dd", this.taskDate[1]) + ' 23:59:59')
      let url = '/buss/report/taskReport'
      this.$ajax.downFile(url, this.queryObj).then((msg) => {
        this.taskloading = false
        this.taskDate = []
        this.$message.success(msg)
      }).catch(err => {
        this.$message.error(err)
        this.taskloading = false
      })
    },
     userReport () {
      this.userloading = true
      if (this.userDate.length === 0 ) {
        this.$message.error("请选择时间范围")
        this.userloading = false
        return
      }
      this.$set(this.queryObj, "startTime", dateutils.dateFormat("YYYY-mm-dd", this.userDate[0]) + ' 00:00:00')
      this.$set(this.queryObj, "endTime", dateutils.dateFormat("YYYY-mm-dd", this.userDate[1]) + ' 23:59:59')
      let url = '/buss/report/userReport'
      this.$ajax.downFile(url, this.queryObj).then((msg) => {
        this.userloading = false
        this.userDate = []
        this.$message.success(msg)
      }).catch(err => {
        this.$message.error(err)
        this.userloading = false
      })
    },
    reportData (orgIds) {
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
    },

  },
  mounted () {
  },
}
</script>
<style scoped>
.box-card {
  margin-bottom: 10px;
}

.report-button {
  margin-top: 10px;
  margin-left: 0px;
}
</style>
